import { Link } from 'react-router-dom';
import CardState from '../../profile/ui/CardState';

function docNames(labels) {
  if (labels.length <= 2) return labels.join(', ');
  return `${labels.slice(0, 2).join(', ')} and ${labels.length - 2} more`;
}

const ROWS = {
  documents: (item) => ({
    pill: 'Missing', tone: 'crit',
    title: `${item.count} employment document${item.count === 1 ? '' : 's'}`,
    detail: docNames(item.labels || []),
  }),
  emergency: () => ({ pill: 'Not set', tone: 'warn', title: 'Emergency contact', detail: 'Add it in Personal details' }),
  address: () => ({ pill: 'Not set', tone: 'warn', title: 'Home address', detail: 'Add it in Personal details' }),
};

export default function AttentionCard({ items, loading = false }) {
  // Hold the card's place while the signals load so it doesn't pop in later.
  // Loaded-and-empty still renders nothing: a cleared checklist stays silent.
  if (loading) {
    return (
      <section className="home-card home-card--pending" aria-labelledby="home-attn-h">
        <div className="home-card__head">
          <h2 id="home-attn-h" className="home-card__title">Needs your attention</h2>
        </div>
        <CardState kind="loading" label="Loading what needs your attention" lines={3} />
      </section>
    );
  }
  if (!items || items.length === 0) return null;
  return (
    <section className="home-card" aria-labelledby="home-attn-h">
      <div className="home-card__head">
        <h2 id="home-attn-h" className="home-card__title">Needs your attention</h2>
        <span
          className="home-count"
          aria-label={`${items.length} ${items.length === 1 ? 'item needs' : 'items need'} your attention`}
        >
          {items.length}
        </span>
      </div>
      <ul className="home-list">
        {items.map((item) => {
          const row = ROWS[item.id](item);
          return (
            <li key={item.id}>
              <Link className="home-row home-row--top" to={`/profile?tab=${item.tab}`}>
                <span className={`home-pill home-pill--${row.tone}`}>{row.pill}</span>
                <span className="home-row__text">
                  <span className="home-row__title" title={row.title}>{row.title}</span>
                  {row.detail && <span className="home-row__detail">{row.detail}</span>}
                </span>
              </Link>
            </li>
          );
        })}
      </ul>
    </section>
  );
}
